var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab flex_v",class:{ selected: _vm.selected }},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }